module.exports = __webpack_public_path__ + "static/media/play_tech.fb0d2ab8.svg";